import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import type { WhatsAppChannel, WhatsAppProvider } from '@workspace/types';
import { WhatsAppChannelPanel } from './WhatsAppChannelPanel';

type WhatsAppChannelDetailDialogProps = {
  channel: WhatsAppChannel | null;
  botLabel: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onChannelUpdated: () => void;
};

function providerLabel(provider: WhatsAppProvider): string {
  if (provider === 'TWILIO') return 'Twilio';
  if (provider === 'WAHA') return 'WhatsApp (número propio)';
  return '360dialog';
}

export function WhatsAppChannelDetailDialog({
  channel,
  botLabel,
  open,
  onOpenChange,
  onChannelUpdated,
}: WhatsAppChannelDetailDialogProps) {
  if (!channel) {
    return null;
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='max-w-3xl max-h-[90vh] overflow-y-auto'>
        <DialogHeader>
          <DialogTitle>Canal WhatsApp</DialogTitle>
          <DialogDescription>
            {botLabel} · {providerLabel(channel.provider)} · {channel.displayPhoneNumber}
          </DialogDescription>
        </DialogHeader>
        <WhatsAppChannelPanel
          instanceBotId={channel.instanceBotId}
          botName={botLabel}
          onChannelChange={onChannelUpdated}
        />
      </DialogContent>
    </Dialog>
  );
}
